<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">About</h2>
      </div>
      <div class="d-flex">
        <div class="justify-content-center">
          <router-link to="/about/add" type="button" class="btn btn-primary my-2 btn-icon-text">
            <i class="fe fe-plus-square mr-2"></i> Add data
          </router-link>
        </div>
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-lg-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Info</h6>
            </div>
            <div class="table-responsive">
              <div class="section section-service-info">
                <div class="">
                  <div class="service-info">
                    <div class="service-info__preview">
                      <b-tabs content-class="mt-3">
                        <form action="" class="form-horizontal mr-5" id="aboutForm" @submit.prevent="submit">
                          <b-tabs  content-class="mt-3">
                            <b-tab :title="language.code" v-for="(language, i) in languages" :key="i">
                              <div class="form-group" v-for="(setting, index) in formData" :key="index">
                                <div class="row row-sm">
                                  <div class="ml-3 col-md-4">
                                    <label class="form-label text-capitalize">{{setting.key}}</label>
                                    <input type="hidden" v-if="setting.type === 'text'" name="key[]" :value="setting.key">
                                    <input type="hidden" v-if="setting.type === 'text'" name="type[]" :value="setting.type">
                                  </div>
                                  <div class="col-md-7 d-flex" v-if="setting.type === 'text'">
                                    <input type="text" class="form-control mr-5" :dir="language.type" :name="'value[][' + language.code + ']'" v-model="setting.value[language.code]" placeholder="Designation">
<!--                                    <button @click="removeAbout(setting.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">-->
<!--                                      <i class="ti-close"></i>-->
<!--                                    </button>-->
                                  </div>
                                  <div class="col-md-7 d-flex justify-content-between" v-else>
                                    <img width="150" :src="setting.value" alt="">
                                    <div>
                                      <router-link :to="'/about/'+ setting.id" class="btn btn-outline-primary mr-2 mt-1 mb-1">
                                        <i class="fe fe-edit"></i>
                                      </router-link>
<!--                                      <button @click="removeAbout(setting.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">-->
<!--                                        <i class="ti-close"></i>-->
<!--                                      </button>-->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </b-tab>
                          </b-tabs>
                          <button type="submit" class="btn btn-primary mt-3 mb-5 mr-1 float-right">Submit</button>
                        </form>
                      </b-tabs>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Settings',
  data () {
    return {
      formData: [],
      tabs: [
        {
          name: 'text'
        },
        {
          name: 'image'
        }
      ],
      upload: false,
      image: null,
      updateImg: false
    }
  },
  computed: {
    ...mapState({
      settingsList: state => state.about.settingsList,
      languages: state => state.language.languages
    })
  },
  created () {
    this.getSettingsList().then(() => {
      console.log(this.settingsList)
      this.formData = [...this.settingsList]
    })
  },
  methods: {
    ...mapActions({
      getSettingsList: 'about/getSettingsList',
      updateSettings: 'about/updateSettings',
      deleteItem: 'about/deleteItem'
    }),
    submit () {
      this.formData = this.formData.filter(item => item.type !== 'image')
      this.updateSettings({ data: this.formData }).then(() => {
        this.$toasted.success('Setting update was successfully!').goAway(1500)
      }).catch(err => {
        if (err && err.response) {
          if (err.response.status === 422) {
            const data = err.response.data.errors
            const keys = Object.keys(data)
            const msg = data[keys[0]]
            this.$toasted.error(msg).goAway(1500)
          } else {
            this.$toasted.error(err.response.message).goAway(1500)
          }
        }
      })
      this.formData = [...this.settingsList]
    },
    removeAbout (id) {
      this.deleteItem(id).then(res => {
        this.formData = [...this.settingsList]
      })
    }
  }
}
</script>
